import React from "react";

function Index() {
  const data = {
    template: [
      { end: "07:00", start: "05:30" },
      { end: "08:30", start: "07:00" },
      { end: "10:00", start: "08:30" },
      { end: "11:30", start: "10:00" },
      { end: "13:00", start: "11:30" },
      { end: "14:30", start: "13:00" },
      { end: "16:00", start: "14:30" },
      { end: "19:00", start: "17:30" },
      { end: "20:30", start: "19:00" },
      { end: "22:00", start: "20:30" },
      { end: "01:00", start: "23:30" },
      { end: "02:30", start: "01:00" },
    ],
    days: {
      sat: {
        date: "2022/01/14",
        times: [
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
        ],
      },
      sun: {
        date: "2022/01/14",
        times: [
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
        ],
      },
      mon: {
        date: "2022/01/14",
        times: [
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
          {
            price: "20000",
            status: "ready",
          },
        ],
      },
    },
  };
  const week = ["sun", "sat", "mon"];
  return (
    <div className="conatiner">
      <div className="card mx-3 mt-2">
        <div className="card-body">
          <div className="row">
            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  {week.map((day, key) => (
                    <th key={key}>{day}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th></th>
                </tr>
                {week.map((day, count) => {
                  return (
                    <tr key={count} className="mx-2">
                      {data.days[day][count].times.map((sans, sansCount) => (
                        <td key={sansCount}>{sans.price}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;

//  <ul style={{ display: "flex" }}>
//             <li
//               style={{
//                 width: "130px",
//               }}
//             ></li>
//             {week.map(day => (
//               <li>
//                 <span
//                   className="border m-1"
//                   style={{
//                     display: "block",
//                     padding: "20px",
//                   }}
//                 >
//                   {day}
//                 </span>
//               </li>
//             ))}
//           </ul>

//           <ul style={{ display: "flex" }}>
//             <li>
//               {data.template.map(temp => (
//                 <span
//                   className="border m-1"
//                   style={{ display: "block", padding: "20px" }}
//                 >{`${temp.start} تا ${temp.end}`}</span>
//               ))}
//             </li>

//             {week.map(day => {
//               return (
//                 <li className="mx-2">
//                   {data.days[day].times.map(sans => (
//                     <span
//                       className="border m-1"
//                       style={{
//                         display: "block",
//                         backgroundColor: "#DDFEE9",
//                         color: "#66C593",
//                         padding: "20px",
//                       }}
//                     >
//                       {sans.price}
//                     </span>
//                   ))}
//                 </li>
//               );
//             })}
//           </ul>
